import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import theme from './ToggleButton.scss';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  active: PropTypes.bool,
  children: PropTypes.node.isRequired,
  text: PropTypes.node,
  className: PropTypes.string,
};
const defaultProps = {
  active: false,
  text: null,
  className: '',
};

const ToggleButton = ({ onChange, active, children, text, className }) => (
  <div className={ classnames(theme.root, className) }>
    { !active &&
      text && (
      <div className={ theme.toolTip }>
        {text}
      </div>
    ) }
    <button
      className={
        classnames(theme.btn, {
          [theme.active]: active,
        })
      }
      onClick={ () => onChange(!active) }
      aria-label={ text }
    >
      { children }
    </button>
  </div>
);
ToggleButton.propTypes = propTypes;
ToggleButton.defaultProps = defaultProps;

export default ToggleButton;
